import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import PropertyRow from 'app/shared/components/soh/PropertyRow';

import {
    AppSelectors,
} from 'app/shared/selectors';

import {
    Table,
    Anchor,
} from '@zillow/constellation';

import HeaderTooltip from 'app/shared/components/Analytics/HeaderTooltip';

import {
    StyledTableContainer,
    StyledTableHeaderCell,
} from './StyledComponents';

const propTypes = {
    listings: PropTypes.array.isRequired,
};

const PropertiesViewList = ({ listings }) => {
    const hideBoostColumn = listings.every(listing => listing.hideBoostColumn);
    const isScreenTabletOrDesktop = useSelector(state => AppSelectors.makeIsScreenTabletOrDesktop(state));
    const isScreenDesktop = useSelector(state => AppSelectors.makeIsScreenDesktop(state));
    const isEnterpriseCustomer = useSelector(state => state.user.isEnterpriseCustomer);

    const show3D = !isEnterpriseCustomer || isScreenDesktop;

    const tooltip = {
        title: '3D Tour ',
        message: (
            <React.Fragment>
                You can add a 3D tour to any of your listings to help it stand out. Use the&nbsp;
                <Anchor href="https://www.zillow.com/z/3d-home/">Zillow 3D capture app</Anchor>
                &nbsp;to create the property tour, then go to the listing to add the 3D tour.
            </React.Fragment>
        ),
    };

    return (
        <StyledTableContainer>
            <Table
                appearance="horizontal"
                aria-label="Medium-sized grid table"
                size="md"
            >
                <Table.Header>
                    <Table.Row>
                        {isScreenTabletOrDesktop && <StyledTableHeaderCell />}
                        <StyledTableHeaderCell>Address</StyledTableHeaderCell>
                        {show3D && (
                            <StyledTableHeaderCell>
                                <HeaderTooltip
                                    title={tooltip.title}
                                    message={tooltip.message}
                                />
                            </StyledTableHeaderCell>
                        )}
                        {(isEnterpriseCustomer && isScreenTabletOrDesktop) && (
                            <React.Fragment>
                                <StyledTableHeaderCell>Listing source</StyledTableHeaderCell>
                                <StyledTableHeaderCell>Advertising</StyledTableHeaderCell>
                            </React.Fragment>
                        )}
                        <StyledTableHeaderCell>Status</StyledTableHeaderCell>
                        {!hideBoostColumn && (
                            <StyledTableHeaderCell>Boost</StyledTableHeaderCell>
                        )}
                        <StyledTableHeaderCell>Actions</StyledTableHeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {listings.map((listing, index) => (
                        <PropertyRow
                            key={index}
                            listing={listing}
                            hideBoost={hideBoostColumn}
                        />
                    ))}
                </Table.Body>
            </Table>
        </StyledTableContainer>
    );
};

PropertiesViewList.propTypes = propTypes;

export { PropertiesViewList };
export default PropertiesViewList;
